import { faEarthAmericas } from "@fortawesome/pro-regular-svg-icons"
import { faLocationDot } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Tab, Tabs, Typography } from "@mui/material"
import { translate } from "app/language/service"
import { IRootState } from "app/model"
import { GEO_TARGETS_FORM_TABS } from "form/model"
import { activateGeoTargetsTab, getGeoTargetsForm } from "form/tools/geo-targets"
import React from "react"
import { connect } from "react-redux"
import { FlexBox } from "ui/components/FlexBox"

interface IGeoTargetsTabsProps {
  isSmallContent: boolean
  activeTab: GEO_TARGETS_FORM_TABS
}

export const GeoTargetsTabsFn = React.memo(
  ({ activeTab, isSmallContent: isTightContent }: IGeoTargetsTabsProps): JSX.Element => (
    <Tabs
      value={activeTab}
      onChange={(_event, newTab: GEO_TARGETS_FORM_TABS) => activateGeoTargetsTab(newTab)}
      sx={{
        "width": "100%",
        "maxWidth": "100%",
        "mb": ".5rem",
        "borderBottom": theme => theme.palette.border,
        "& .MuiButtonBase-root.MuiTab-root.Mui-selected": {
          color: theme => theme.palette.text.primary,
          fontWeight: 500
        },
        "& .MuiButtonBase-root.MuiTab-root": {
          fontWeight: 300
        },
        "& .MuiTabs-scrollButtons svg": {
          color: theme => theme.palette.text.primary
        },
        "& .MuiTypography-root": {
          fontSize: ".9rem",
          fontWeight: 500
        },
        "&, & .MuiButtonBase-root": {
          minHeight: "2rem",
          maxHeight: "2rem"
        }
      }}
      variant={isTightContent ? "scrollable" : "standard"}
      scrollButtons
      allowScrollButtonsMobile>
      <Tab
        id="geo-target-tab-shape"
        value={GEO_TARGETS_FORM_TABS.SHAPE}
        label={
          <FlexBox gap="1rem" jc="center">
            <FontAwesomeIcon icon={faEarthAmericas} />
            <Typography color="textPrimary">{translate("campaign.geo-targets.tab.shape.title")}</Typography>
          </FlexBox>
        }
      />
      <Tab
        id="geo-target-tab-coordinate"
        value={GEO_TARGETS_FORM_TABS.COORDINATE}
        label={
          <FlexBox gap="1rem" jc="center">
            <FontAwesomeIcon icon={faLocationDot} />
            <Typography color="textPrimary">{translate("campaign.geo-targets.tab.coordinate.title")}</Typography>
          </FlexBox>
        }
      />
    </Tabs>
  )
)

export const GeoTargetsTabs = connect(
  (state: IRootState): IGeoTargetsTabsProps => ({
    activeTab: getGeoTargetsForm(state).activeTab,
    isSmallContent: state.ui.contentWidth < 333
  })
)(GeoTargetsTabsFn)
